import { ApiBase } from "./ApiBase";
import { Tab } from "typings";

export class TabAPI extends ApiBase
{
    async getTabs(): Promise<Tab[]>
    {
        const response = await this.fetch("tab");
        return response.json();
    }
}


// WEBPACK FOOTER //
// ./src/services/tab.ts